<template>
  <div
    class="min-h-screen rounded-3xl border border-black/5 dark:border-white/10 shadow-apple bg-zinc-50 text-zinc-900 dark:bg-zinc-950 dark:text-zinc-50 flex items-stretch justify-center">
    <div class="w-full max-w-6xl mx-auto px-4 py-6 sm:py-8 lg:py-10">
      <header class="flex flex-col gap-4 mb-6 lg:mb-8 sm:flex-row sm:items-start sm:justify-between">
        <div class="flex items-start gap-3">
          <button type="button" @click="goBack"
            class="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-zinc-100 dark:bg-zinc-900/80 border border-zinc-200 dark:border-zinc-800 text-zinc-500 hover:text-zinc-950 dark:hover:text-zinc-50 hover:border-[#0EA5E9]/70 transition-colors">
            <span class="material-symbols-rounded text-[18px]">
              chevron_left
            </span>
          </button>
          <div class="min-w-0 space-y-1">
            <p class="text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-zinc-500 dark:text-zinc-400">
              Assets library
            </p>
            <div class="flex flex-wrap items-center gap-2">
              <h1 class="text-xl sm:text-2xl font-semibold tracking-tight truncate">
                <span v-if="!group">All folders</span>
                <span v-else>{{ group }}</span>
              </h1>
              <span v-if="group"
                class="inline-flex items-center gap-1 rounded-full border border-black/10 dark:border-white/10 bg-white/80 dark:bg-[#171719] px-2.5 py-1 text-[11px] font-medium text-zinc-600 dark:text-zinc-300">
                <span class="h-1.5 w-1.5 rounded-full bg-[#0EA5E9]"></span>
                {{ filteredItems.length }} of {{ total }} files
              </span>
            </div>

            <p v-if="!group" class="text-xs sm:text-sm text-zinc-600 dark:text-zinc-400">
              Centralize all your exports into curated folders for each project or client.
            </p>

            <div v-else
              class="flex flex-wrap items-center gap-1.5 text-[11px] sm:text-sm text-zinc-600 dark:text-zinc-400">
              <span>{{ density === 'comfy' ? 'Comfy grid' : 'Compact grid' }}</span>
              <span class="opacity-40">•</span>
              <span>
                {{
                  filterType === 'all'
                    ? 'All file types'
                    : filterType === 'images'
                      ? 'Images only'
                      : 'Fonts (.otf)'
                }}
              </span>
              <span class="opacity-40">•</span>
              <span class="capitalize">
                {{
                  sortOrder === 'new'
                    ? 'Newest first'
                    : sortOrder === 'old'
                      ? 'Oldest first'
                      : sortOrder === 'size'
                        ? 'By size'
                        : 'By name'
                }}
              </span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-3 w-full sm:w-auto sm:items-end sm:min-w-[260px] sm:max-w-sm">
          <div class="flex items-center gap-2 w-full justify-end">

            <router-link to="/dashboard/hub"
              class="h-10 w-10 shrink-0 rounded-xl border border-black/10 dark:border-white/10 bg-white/90 dark:bg-[#171719] hover:bg-black/5 dark:hover:bg-white/5 transition-colors flex items-center justify-center group"
              title="Tutorial Hub">
              <span
                class="material-symbols-outlined text-[20px] text-zinc-500 group-hover:text-[#0EA5E9] transition-colors group-hover:rotate-12 duration-300">school</span>
            </router-link>

            <div v-if="!group"
              class="inline-flex flex-1 sm:flex-none items-center rounded-full border border-black/10 dark:border-white/10 bg-white/90 dark:bg-[#171719]/80 p-0.5 text-xs shadow-sm shadow-black/5 dark:shadow-black/40">
              <button type="button" class="flex-1 sm:flex-none px-3 py-1.5 rounded-full transition-colors text-center"
                :class="activeTab === 'recent' ? 'bg-[#0EA5E9] text-white shadow-sm shadow-[#0EA5E9]/40' : 'text-zinc-600 dark:text-zinc-300 hover:bg-zinc-100/70 dark:hover:bg-zinc-800/60'"
                @click="activeTab = 'recent'">
                Recent
              </button>
              <button type="button" class="flex-1 sm:flex-none px-3 py-1.5 rounded-full transition-colors text-center"
                :class="activeTab === 'all' ? 'bg-[#0EA5E9] text-white shadow-sm shadow-[#0EA5E9]/40' : 'text-zinc-600 dark:text-zinc-300 hover:bg-zinc-100/70 dark:hover:bg-zinc-800/60'"
                @click="activeTab = 'all'">
                All folders
              </button>
            </div>

            <div v-if="group" class="flex-1 ...">
            </div>

          </div>
          <div v-if="group"
            class="w-full flex flex-col gap-2 rounded-2xl border border-black/5 dark:border-white/5 bg-white/80 dark:bg-[#101012]/90 p-2.5 backdrop-blur-sm">
            <div class="flex gap-2 w-full">
              <div class="relative flex-1">
                <input v-model.trim="searchQuery" type="search" placeholder="Search files by name..."
                  class="h-9 w-full rounded-xl border border-black/10 dark:border-white/10 bg-zinc-50/80 dark:bg-[#171719] pl-3 pr-9 text-xs outline-none focus:ring-2 focus:ring-[#0EA5E9]/50 focus:border-[#0EA5E9]/70 transition-all" />
                <button v-if="searchQuery"
                  class="absolute right-1 top-1 h-7 w-7 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 grid place-items-center"
                  @click="searchQuery = ''">
                  <span class="material-symbols-outlined text-[16px]">close</span>
                </button>
              </div>
            </div>
            <div class="flex gap-2 text-[11px]">
              <select v-model="filterType"
                class="h-8 flex-1 rounded-xl border border-black/10 dark:border-white/10 bg-zinc-50/80 dark:bg-[#171719] px-2 outline-none focus:ring-2 focus:ring-[#0EA5E9]/40">
                <option value="all">All types</option>
                <option value="images">Images only</option>
                <option value="fonts">Fonts (.otf)</option>
              </select>
              <select v-model="sortOrder"
                class="h-8 flex-1 rounded-xl border border-black/10 dark:border-white/10 bg-zinc-50/80 dark:bg-[#171719] px-2 outline-none focus:ring-2 focus:ring-[#0EA5E9]/40">
                <option value="new">Newest</option>
                <option value="old">Oldest</option>
                <option value="size">Size</option>
                <option value="name">Name</option>
              </select>
            </div>
          </div>

          <input ref="fileInput" type="file" class="hidden" multiple accept="image/*,.otf" @change="onFilesPicked" />

          <div v-if="group" class="flex items-center gap-2 w-full">
            <button
              class="h-10 px-3 flex-1 rounded-xl text-sm border border-black/10 dark:border-white/10 bg-white/90 dark:bg-[#171719] hover:bg-black/5 dark:hover:bg-white/5 transition-colors flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
              @click="fileInput?.click()" :disabled="isLoading || isUploading">
              <span class="material-symbols-outlined text-[18px]">upload</span>
              <span v-if="!isUploading">Upload files</span>
              <span v-else>Uploading…</span>
            </button>
            <button
              class="h-10 px-3 flex-shrink-0 rounded-xl text-sm border border-black/10 dark:border-white/10 bg-white/90 dark:bg-[#171719] hover:bg-black/5 dark:hover:bg-white/5 transition-colors flex items-center justify-center gap-2"
              @click="setGroup(null)">
              <span class="material-symbols-outlined text-[18px]">folder</span>
              <span>Folders</span>
            </button>
          </div>
        </div>
      </header>

      <main class="space-y-6">
        <section v-if="!group" class="space-y-4">
          <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 rounded-2xl border border-black/5 dark:border-white/10 bg-white/90 dark:bg-[#101012]/90 px-3 sm:px-4 py-3">
            <div class="space-y-0.5">
              <h2 class="text-sm font-semibold text-zinc-800 dark:text-zinc-50">
                Folders overview
              </h2>
              <p class="text-xs text-zinc-500 dark:text-zinc-400">
                Group exports by projects, clients or experiments to keep everything organized.
              </p>
            </div>
            <div class="flex items-center gap-2">
              <button type="button"
                class="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-xl border border-[#0EA5E9]/40 bg-[#0EA5E9]/10 px-3 py-1.5 text-xs font-medium text-[#0369A1] dark:text-[#7DD3FC] hover:bg-[#0EA5E9]/15 hover:border-[#0EA5E9]/70 transition-colors"
                @click="isCreateModalOpen = true">
                <span class="material-symbols-outlined text-[18px]">create_new_folder</span>
                <span>New folder</span>
              </button>
            </div>
          </div>

          <TransitionGroup tag="div" name="list" @before-enter="onBeforeEnter" @enter="onEnter"
            class="grid gap-3 sm:gap-4 grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
            <div key="new-folder-key" :data-index="0" class="h-full">
              <button
                class="aspect-[4/3] w-full rounded-2xl border-2 border-dashed border-black/10 dark:border-white/10 flex flex-col items-center justify-center gap-2 hover:bg-black/5 dark:hover:bg-white/5 transition-all duration-300 hover:border-[#0EA5E9]/60"
                @click="isCreateModalOpen = true">
                <div
                  class="h-12 w-12 rounded-2xl border border-dashed border-zinc-300 dark:border-zinc-600 grid place-items-center">
                  <span class="material-symbols-outlined text-3xl text-zinc-400 dark:text-zinc-600">
                    add
                  </span>
                </div>
                <div class="text-center px-3">
                  <p class="text-sm font-medium">Create folder</p>
                  <p class="text-[11px] text-zinc-500 dark:text-zinc-400">
                    Start a new collection of assets
                  </p>
                </div>
              </button>
            </div>

            <div v-for="(g, idx) in visibleFolders" :key="g.name" :data-index="idx + 1"
              class="relative rounded-2xl border border-black/10 dark:border-white/10 bg-gradient-to-br from-zinc-50 to-zinc-100 dark:from-[#121218] dark:to-[#18181F] group transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0EA5E9]/12 hover:border-[#0EA5E9]/60 cursor-pointer"
              @click="setGroup(g.name)">
              <div class="p-3.5 h-full flex flex-col gap-3 relative z-10 rounded-2xl overflow-hidden">
                <div class="flex items-center justify-between gap-2">
                  <div
                    class="h-9 w-9 rounded-2xl bg-[#0EA5E9]/10 text-[#0EA5E9] grid place-items-center border border-[#0EA5E9]/20">
                    <span class="material-symbols-outlined text-[22px]">
                      folder
                    </span>
                  </div>
                  <button
                    class="h-8 w-8 grid place-items-center rounded-xl bg-black/5 dark:bg-white/5 text-zinc-600 dark:text-zinc-200 hover:bg-black/10 dark:hover:bg-white/10 transition-colors"
                    @click.stop="toggleFolderMenu(idx)">
                    <span class="material-symbols-outlined text-[20px]">
                      more_vert
                    </span>
                  </button>
                </div>

                <div class="space-y-1 flex-1 min-h-[40px]">
                  <p class="text-sm font-semibold truncate">
                    {{ g.name }}
                  </p>
                  <p class="text-xs text-zinc-500 dark:text-zinc-400 truncate">
                    {{ g.count }} file(s) • {{ formatBytes(g.size) }}
                  </p>
                </div>

                <div class="flex items-center justify-between text-[11px] text-zinc-500 dark:text-zinc-400">
                  <div class="inline-flex items-center gap-1">
                    <span class="h-1.5 w-1.5 rounded-full bg-emerald-400"></span>
                    <span>Active folder</span>
                  </div>
                  <span class="inline-flex items-center gap-1">
                    <span class="material-symbols-outlined text-[16px]">
                      chevron_right
                    </span>
                    Open
                  </span>
                </div>
              </div>

              <Transition name="menu">
                <div v-if="openFolderMenuIndex === idx"
                  class="absolute right-3 top-11 w-44 rounded-xl border border-black/15 dark:border-white/10 bg-white/95 dark:bg-[#171719] shadow-xl shadow-black/40 p-1 z-20 origin-top-right">
                  <button
                    class="w-full flex items-center gap-2 px-2 py-2 rounded-lg text-left text-sm text-zinc-700 dark:text-zinc-200 hover:bg-black/5 dark:hover:bg-white/5"
                    @click="copyFolderLink(g)">
                    <span class="material-symbols-outlined text-[18px]">
                      link
                    </span>
                    <span>Copy link</span>
                  </button>
                  <button
                    class="w-full flex items-center gap-2 px-2 py-2 rounded-lg text-left text-sm text-zinc-700 dark:text-zinc-200 hover:bg-black/5 dark:hover:bg-white/5"
                    @click="startRename(g.name)">
                    <span class="material-symbols-outlined text-[18px]">
                      edit
                    </span>
                    <span>Rename</span>
                  </button>
                  <button
                    class="w-full flex items-center gap-2 px-2 py-2 rounded-lg text-left text-sm text-red-500 hover:bg-red-500/10 dark:hover:bg-red-500/15"
                    @click="confirmDeleteGroup(g.name)">
                    <span class="material-symbols-outlined text-[18px]">
                      delete
                    </span>
                    <span>Delete</span>
                  </button>
                </div>
              </Transition>
            </div>

          </TransitionGroup>
        </section>

        <section v-else class="space-y-4">
          <div v-if="error" class="mb-1 p-3 rounded-xl border border-red-400/60 bg-red-500/10 text-red-200 text-sm">
            {{ error }}
          </div>

          <div v-if="!isLoading && filteredItems.length === 0 && !isInitialLoading" class="py-16 sm:py-20 text-center">
            <div class="mx-auto max-w-md space-y-3 px-4">
              <div
                class="h-24 w-24 sm:h-28 sm:w-28 mx-auto rounded-2xl bg-gradient-to-br from-[#0EA5E9]/20 to-cyan-400/20 ring-1 ring-black/10 dark:ring-white/10 grid place-items-center">
                <span class="material-symbols-outlined text-3xl sm:text-4xl text-[#0EA5E9]">
                  folder_off
                </span>
              </div>
              <h2 class="text-base sm:text-lg font-medium">This folder is empty</h2>
              <p class="text-xs sm:text-sm text-zinc-500 dark:text-zinc-400">
                Drag and drop assets here or use the upload button to start building this collection.
              </p>
            </div>
          </div>

          <div
            class="relative rounded-2xl border border-dashed border-transparent bg-transparent transition-colors duration-300"
            :class="{ 'bg-[#0EA5E9]/5 border-[#0EA5E9]': isDraggingOver }" @dragover.prevent="isDraggingOver = true"
            @dragleave.prevent="isDraggingOver = false" @drop.prevent="onFilesDropped">
            <div class="grid gap-2.5 sm:gap-3 md:gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 p-1.5">
              <TransitionGroup name="list" @before-enter="onBeforeEnter" @enter="onEnter">
                <template v-if="isInitialLoading">
                  <div v-for="i in 10" :key="`skel-${i}`" :data-index="i"
                    class="rounded-2xl border border-black/10 dark:border-white/10 bg-white/70 dark:bg-[#171719]/70 aspect-[4/5] flex flex-col overflow-hidden">
                    <div class="flex-1 bg-black/5 dark:bg-white/5 animate-pulse"></div>
                    <div class="p-2.5 space-y-1.5">
                      <div class="h-3 w-3/4 bg-black/10 dark:bg-white/10 rounded animate-pulse"></div>
                      <div class="h-3 w-1/3 bg-black/10 dark:bg-white/10 rounded animate-pulse"></div>
                    </div>
                  </div>
                </template>

                <div v-for="(item, idx) in pagedItems" :key="item.url" :data-index="idx"
                  class="group relative z-0 rounded-2xl border border-black/10 dark:border-white/10 bg-white/90 dark:bg-[#171719] transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0EA5E9]/16 hover:border-[#0EA5E9]/60 aspect-[4/5] flex flex-col"
                  :class="{
                    'ring-2 ring-[#0EA5E9] ring-offset-2 ring-offset-zinc-50 dark:ring-offset-zinc-950': isSelected(item),
                    'z-30': openItemMenu === item.url
                  }" draggable="true" @dragstart="onDragStart(item)">
                  <div class="relative flex-1 w-full overflow-hidden rounded-2xl">
                    <img v-if="isImage(item.filename)" :src="item.absoluteUrl || item.url"
                      class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                    <div v-else-if="isFont(item.filename)"
                      class="w-full h-full grid place-items-center bg-zinc-100 dark:bg-[#101012] p-3 sm:p-4">
                      <p class="text-lg sm:text-2xl text-center truncate text-zinc-800 dark:text-zinc-100"
                        :style="{ fontFamily: `font-preview-${item.url.replace(/[^a-zA-Z0-9]/g, '')}` }"
                        @mouseenter="loadAndApplyFont(item)">
                        {{ item.filename.replace('.otf', '') }}
                      </p>
                    </div>
                    <div v-else class="w-full h-full grid place-items-center bg-black/5 dark:bg-white/5">
                      <span class="material-symbols-outlined text-3xl sm:text-4xl text-zinc-400 dark:text-zinc-600">
                        description
                      </span>
                    </div>

                    <button
                      class="absolute left-1.5 top-1.5 sm:left-2 sm:top-2 h-7 w-7 rounded-md grid place-items-center bg-white/95 dark:bg-[#0F1012]/95 ring-1 ring-black/10 dark:ring-white/10 text-zinc-600 dark:text-zinc-300"
                      @click.stop="toggleSelection(item)">
                      <span class="material-symbols-outlined text-[18px] transition-colors"
                        :class="{ 'text-[#0EA5E9]': isSelected(item) }">
                        {{ isSelected(item) ? 'check_box' : 'check_box_outline_blank' }}
                      </span>
                    </button>

                    <div
                      class="absolute right-1.5 top-1.5 sm:right-2 sm:top-2 flex gap-1 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition">
                      <button
                        class="h-7 w-7 sm:h-8 sm:w-8 grid place-items-center rounded-md bg-white/95 dark:bg-[#0F1012]/95 ring-1 ring-black/10 dark:ring-white/10"
                        @click.stop="openLightbox(item)">
                        <span class="material-symbols-outlined text-[18px]">
                          open_in_full
                        </span>
                      </button>
                      <button
                        class="h-7 w-7 sm:h-8 sm:w-8 grid place-items-center rounded-md bg-white/95 dark:bg-[#0F1012]/95 ring-1 ring-black/10 dark:ring-white/10"
                        @click.stop="toggleItemMenu(item)">
                        <span class="material-symbols-outlined text-[18px]">
                          more_vert
                        </span>
                      </button>
                    </div>
                  </div>

                  <Transition name="menu">
                    <div v-if="openItemMenu === item.url"
                      class="absolute right-2 top-10 w-40 rounded-xl border border-black/15 dark:border-white/10 bg-white/95 dark:bg-[#171719] shadow-xl shadow-black/40 p-1 z-40 origin-top-right">
                      <button
                        class="w-full flex items-center gap-2 px-2 py-2 rounded-lg text-left text-sm text-red-500 hover:bg-red-500/10 dark:hover:bg-red-500/15"
                        @click="confirmDeleteItem(item)">
                        <span class="material-symbols-outlined text-[18px]">
                          delete
                        </span>
                        <span>Delete</span>
                      </button>
                    </div>
                  </Transition>
                </div>

              </TransitionGroup>
            </div>
          </div>

          <div ref="sentinel" class="h-8 sm:h-10"></div>
          <div v-if="isLoading && !isInitialLoading"
            class="py-4 sm:py-6 text-center text-zinc-500 dark:text-zinc-400 text-xs sm:text-sm">
            Loading…
          </div>

          <ImageLightbox :open="isLightboxOpen" :item="activeItem" @close="isLightboxOpen = false" @next="goToNextItem"
            @prev="goToPreviousItem" />

          <Transition name="slide-up">
            <div v-if="selectedItemsCount"
              class="fixed inset-x-3 sm:left-1/2 sm:-translate-x-1/2 bottom-3 sm:bottom-4 z-40">
              <div
                class="w-full sm:w-[min(720px,90vw)] mx-auto rounded-2xl border border-black/20 dark:border-white/10 bg-white/90 dark:bg-[#101012]/90 backdrop-blur-md shadow-2xl shadow-black/50 p-3">
                <div class="flex flex-col sm:flex-row items-center justify-between gap-3">
                  <div class="text-sm">
                    <span class="font-semibold">{{ selectedItemsCount }}</span>
                    <span class="ml-1">file(s) selected</span>
                  </div>
                  <div class="flex items-center gap-2 flex-wrap justify-center">
                    <button
                      class="h-9 px-3 rounded-xl text-xs sm:text-sm border border-black/10 dark:border-white/10 bg-white/90 dark:bg-[#171719] hover:bg-black/5 dark:hover:bg-white/5 flex items-center gap-2"
                      @click="selectAllVisible">
                      <span class="material-symbols-outlined text-[18px]">
                        select_all
                      </span>
                      <span>Select all</span>
                    </button>
                    <button
                      class="h-9 px-3 rounded-xl text-xs sm:text-sm border border-black/10 dark:border-white/10 bg-white/90 dark:bg-[#171719] hover:bg-black/5 dark:hover:bg-white/5 flex items-center gap-2"
                      @click="clearSelection">
                      <span class="material-symbols-outlined text-[18px]">
                        deselect
                      </span>
                      <span>Clear</span>
                    </button>
                    <button
                      class="h-9 px-3 rounded-xl text-xs sm:text-sm bg-red-500 text-white hover:bg-red-400 flex items-center gap-2"
                      @click="confirmBulkDelete">
                      <span class="material-symbols-outlined text-[18px]">
                        delete
                      </span>
                      <span>Delete</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </section>
      </main>

      <Transition name="modal">
        <div v-if="isCreateModalOpen || isRenameModalOpen || isConfirmModalOpen"
          class="fixed inset-0 bg-black/60 backdrop-blur-sm grid place-items-center p-4 z-50" @click.self="
            isCreateModalOpen = false;
          isRenameModalOpen = false;
          closeConfirmModal()
            ">
          <div v-if="isCreateModalOpen"
            class="w-full max-w-sm rounded-2xl border border-black/15 dark:border-white/10 bg-white dark:bg-[#101012] p-4 space-y-3 shadow-2xl shadow-black/50">
            <h4 class="text-sm font-semibold">New folder</h4>
            <input v-model.trim="newGroupName" type="text"
              class="h-10 w-full rounded-xl border border-black/10 dark:border-white/10 bg-white dark:bg-[#171719] px-3 text-sm outline-none focus:ring-2 focus:ring-[#0EA5E9]/50 focus:border-[#0EA5E9]/70"
              placeholder="Folder name" />
            <div class="flex flex-col sm:flex-row justify-end gap-2">
              <button
                class="h-9 px-3 rounded-lg text-sm text-zinc-700 dark:text-zinc-200 hover:bg-black/5 dark:hover:bg-white/5"
                @click="isCreateModalOpen = false">
                Cancel
              </button>
              <button
                class="h-9 px-3 rounded-lg text-sm bg-[#0EA5E9] text-zinc-950 hover:bg-sky-400 flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed shadow-sm shadow-[#0EA5E9]/40"
                :disabled="!newGroupName" @click="createNewGroup">
                <span class="material-symbols-outlined text-[18px]">add</span>
                <span>Create</span>
              </button>
            </div>
          </div>

          <div v-if="isRenameModalOpen"
            class="w-full max-w-sm rounded-2xl border border-black/15 dark:border-white/10 bg-white dark:bg-[#101012] p-4 space-y-3 shadow-2xl shadow-black/50">
            <h4 class="text-sm font-semibold">Rename folder</h4>
            <input v-model.trim="renameToName" type="text"
              class="h-10 w-full rounded-xl border border-black/10 dark:border-white/10 bg-white dark:bg-[#171719] px-3 text-sm outline-none focus:ring-2 focus:ring-[#0EA5E9]/50 focus:border-[#0EA5E9]/70"
              placeholder="New name" />
            <div class="flex flex-col sm:flex-row justify-end gap-2">
              <button
                class="h-9 px-3 rounded-lg text-sm text-zinc-700 dark:text-zinc-200 hover:bg-black/5 dark:hover:bg-white/5"
                @click="isRenameModalOpen = false">
                Cancel
              </button>
              <button
                class="h-9 px-3 rounded-lg text-sm bg-[#0EA5E9] text-zinc-950 hover:bg-sky-400 flex items-center gap-2 shadow-sm shadow-[#0EA5E9]/40"
                @click="applyRename">
                <span class="material-symbols-outlined text-[18px]">check</span>
                <span>Rename</span>
              </button>
            </div>
          </div>

          <div v-if="isConfirmModalOpen" class="w-full max-w-sm rounded-2xl border border-black/15 dark:border-white/10 
         bg-white dark:bg-[#101012] px-5 pt-4 pb-5 space-y-4 shadow-2xl shadow-black/50">
            <!-- Título + ícone -->
            <div class="flex items-center gap-2 text-sm font-semibold text-red-500">
              <span class="material-symbols-rounded text-[18px]">warning</span>
              <span>{{ confirmTitle }}</span>
            </div>

            <!-- Mensagem -->
            <p class="text-[13px] leading-relaxed text-zinc-700 dark:text-zinc-300">
              {{ confirmMessage }}
            </p>

            <!-- Botões lado a lado (igual foto) -->
            <div class="flex items-center justify-end gap-2 pt-2">
              <!-- Cancel -->
              <button class="h-9 px-4 rounded-xl text-sm border border-black/10 dark:border-white/10 
             bg-white dark:bg-[#171719] text-zinc-700 dark:text-zinc-200 
             hover:bg-black/5 dark:hover:bg-white/5 transition-colors" :disabled="isConfirmBusy"
                @click="closeConfirmModal">
                Cancel
              </button>

              <!-- Delete -->
              <button class="h-9 px-4 rounded-full bg-red-500 text-white text-sm font-medium 
             hover:bg-red-400 transition-colors flex items-center gap-2
             disabled:opacity-60 disabled:cursor-not-allowed shadow-sm shadow-red-500/40" :disabled="isConfirmBusy"
                @click="executeConfirmAction">
                <span class="material-symbols-rounded text-[18px]">delete</span>
                <span>{{ confirmPrimaryActionText }}</span>
              </button>
            </div>
          </div>

        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  listPreviews,
  listGroups as apiListGroups,
  createGroup,
  renameGroup,
  deleteGroup,
  uploadImages,
  deleteImage,
  sanitizeGroupName
} from '@/api/images'
import ImageLightbox from '@/components/images/ImageLightbox.vue'

const route = useRoute()
const router = useRouter()

const items = ref([])
const total = ref(0)
const skip = ref(0)
const take = ref(60)
const isLoading = ref(false)
const isUploading = ref(false)
const isInitialLoading = ref(true)
const isDone = ref(false)
const error = ref(null)
const sentinel = ref(null)
const searchQuery = ref('')
const sortOrder = ref('new')
const filterType = ref('all')
const density = ref('comfy')
const group = ref(null)
const groups = ref([])
const activeTab = ref('recent')
const openFolderMenuIndex = ref(null)
const isLightboxOpen = ref(false)
const activeItem = ref(null)
const draggedItem = ref(null)
const isCreateModalOpen = ref(false)
const newGroupName = ref('')
const isRenameModalOpen = ref(false)
const renameFromName = ref(null)
const renameToName = ref('')
const fileInput = ref(null)
const isConfirmModalOpen = ref(false)
const confirmTitle = ref('')
const confirmMessage = ref('')
const confirmPrimaryActionText = ref('Delete')
const isConfirmBusy = ref(false)
const confirmAction = ref(async () => { })
const openItemMenu = ref(null)
const selectedItems = ref(new Set())
const isDraggingOver = ref(false)
const loadedFonts = ref(new Set())

function goBack() {
  router.back()
}

function onBeforeEnter(el) {
  el.style.opacity = 0
  el.style.transform = 'translateY(30px)'
}

function onEnter(el, done) {
  const delay = el.dataset.index * 50
  setTimeout(() => {
    el.style.opacity = 1
    el.style.transform = 'translateY(0)'
    el.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
    done()
  }, delay)
}

function openConfirmModal(title, message, action, primaryText = 'Delete') {
  confirmTitle.value = title
  confirmMessage.value = message
  confirmAction.value = action
  confirmPrimaryActionText.value = primaryText
  isConfirmModalOpen.value = true
}

function closeConfirmModal() {
  if (isConfirmBusy.value) return
  isConfirmModalOpen.value = false
}

async function executeConfirmAction() {
  try {
    isConfirmBusy.value = true
    await confirmAction.value()
    isConfirmModalOpen.value = false
  } catch (e) {
    error.value = e?.message || 'Operation failed'
  } finally {
    isConfirmBusy.value = false
  }
}

function isImage(filename) {
  return /\.(png|jpe?g|gif|webp|bmp|svg|avif)$/i.test(filename || '')
}

function isFont(filename) {
  return /\.otf$/i.test(filename || '')
}

function formatBytes(n) {
  if (!n && n !== 0) return ''
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let i = 0
  let value = n
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024
    i++
  }
  return `${value.toFixed(value >= 10 || i === 0 ? 0 : 1)} ${units[i]}`
}

function toggleFolderMenu(index) {
  openFolderMenuIndex.value = openFolderMenuIndex.value === index ? null : index
  const close = () => {
    openFolderMenuIndex.value = null
    window.removeEventListener('click', close)
  }
  window.addEventListener('click', close, { once: true })
}

function toggleItemMenu(item) {
  openItemMenu.value = openItemMenu.value === item.url ? null : item.url
  const close = () => {
    openItemMenu.value = null
    window.removeEventListener('click', close)
  }
  window.addEventListener('click', close, { once: true })
}

async function copyFolderLink(folder) {
  try {
    const resolved = router.resolve({ name: 'galeria', params: { gid: folder.name } })
    const url = new URL(resolved.href, window.location.origin).toString()
    await navigator.clipboard.writeText(url)
  } catch {
    //
  }
}

function openLightbox(item) {
  activeItem.value = item
  isLightboxOpen.value = true
}

async function loadGroups() {
  groups.value = await apiListGroups()
}

async function loadMore() {
  if (isLoading.value || isDone.value || !group.value) return
  isLoading.value = true
  error.value = null
  try {
    const data = await listPreviews({
      group: group.value,
      skip: skip.value,
      take: take.value,
      q: searchQuery.value,
      sort: sortOrder.value
    })
    total.value = data.total || 0
    const newItems = data.items || []
    if (newItems.length) {
      items.value.push(...newItems)
      skip.value += newItems.length
    }
    if (!newItems.length || items.value.length >= total.value) isDone.value = true
  } catch (e) {
    error.value = e?.message || 'Failed to load items'
  } finally {
    isLoading.value = false
    isInitialLoading.value = false
  }
}

async function refresh() {
  if (!group.value) {
    await loadGroups()
    items.value = []
    total.value = 0
    skip.value = 0
    isDone.value = true
    isInitialLoading.value = false
    return
  }
  items.value = []
  total.value = 0
  skip.value = 0
  isDone.value = false
  isInitialLoading.value = true
  await loadMore()
}

function setGroup(groupName) {
  router.push({ name: 'galeria', params: { gid: groupName || undefined } })
}

function startRename(name) {
  renameFromName.value = name
  renameToName.value = name
  isRenameModalOpen.value = true
}

async function applyRename() {
  const from = sanitizeGroupName(renameFromName.value || '')
  const to = sanitizeGroupName(renameToName.value || '')

  if (!from || !to) {
    error.value = 'Folder name can’t be empty'
    return
  }
  if (from === to) {
    isRenameModalOpen.value = false
    return
  }

  const exists = groups.value.some(g => sanitizeGroupName(g.name) === to)
  if (exists) {
    error.value = 'A folder with this name already exists'
    return
  }

  try {
    error.value = null
    await renameGroup(from, to)

    const idx = groups.value.findIndex(g => sanitizeGroupName(g.name) === from)
    if (idx !== -1) {
      const g = { ...groups.value[idx], name: to }
      groups.value.splice(idx, 1, g)
    }

    if (sanitizeGroupName(group.value || '') === from) {
      group.value = to
      router.replace({ name: 'galeria', params: { gid: to } })
    }

    isRenameModalOpen.value = false
    await loadGroups()
    await refresh()
  } catch (e) {
    const msg = e?.response?.data?.message || e?.message || 'Failed to rename folder'
    error.value = msg
  }
}

async function createNewGroup() {
  if (!newGroupName.value) return
  await createGroup(newGroupName.value)
  newGroupName.value = ''
  isCreateModalOpen.value = false
  await loadGroups()
}

async function confirmDeleteGroup(name) {
  openConfirmModal('Delete Folder', `Are you sure you want to delete ${name}?`, async () => {
    await deleteGroup(name)
    if (group.value === name) router.replace({ name: 'galeria' })
    await loadGroups()
    if (group.value === name) {
      group.value = null
      await refresh()
    }
  })
  openFolderMenuIndex.value = null
}

function onDragStart(item) {
  draggedItem.value = item
}

const pageSize = ref(40)
const pageCursor = ref(40)

const filteredItems = computed(() => {
  const term = searchQuery.value.trim().toLowerCase()
  let arr = term
    ? items.value.filter(i => (i.filename || '').toLowerCase().includes(term))
    : [...items.value]

  if (filterType.value === 'images') arr = arr.filter(i => isImage(i.filename))
  else if (filterType.value === 'fonts') arr = arr.filter(i => isFont(i.filename))

  if (sortOrder.value === 'new') arr.sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt))
  else if (sortOrder.value === 'old') arr.sort((a, b) => +new Date(a.createdAt) - +new Date(b.createdAt))
  else if (sortOrder.value === 'size') arr.sort((a, b) => (b.size || 0) - (a.size || 0))
  else if (sortOrder.value === 'name') arr.sort((a, b) => (a.filename || '').localeCompare(b.filename || ''))

  return arr
})

const visibleFolders = computed(() => {
  if (activeTab.value === 'recent') {
    return [...groups.value].sort((a, b) => (b.count || 0) - (a.count || 0))
  }
  return groups.value
})

const pagedItems = computed(() => filteredItems.value.slice(0, pageCursor.value))

let intersectionObserver = null

onMounted(async () => {
  await loadGroups()
  const groupId = route.params.gid ? String(route.params.gid) : null
  group.value = groupId || null
  if (group.value) await refresh()
  else {
    isInitialLoading.value = false
    isDone.value = true
  }

  intersectionObserver = new IntersectionObserver(
    entries => {
      const entry = entries[0]
      if (entry?.isIntersecting) {
        if (group.value && !isDone.value) loadMore()
        else pageCursor.value = Math.min(pageCursor.value + pageSize.value, filteredItems.value.length)
      }
    },
    { rootMargin: '200px' }
  )
  if (sentinel.value) intersectionObserver.observe(sentinel.value)
  window.addEventListener('keydown', onKeyDown)
})

onUnmounted(() => {
  if (intersectionObserver && sentinel.value) intersectionObserver.unobserve(sentinel.value)
  window.removeEventListener('keydown', onKeyDown)
})

watch([searchQuery, sortOrder, filterType], () => {
  pageCursor.value = Math.min(Math.max(pageSize.value, pageCursor.value), filteredItems.value.length)
  if (group.value) {
    skip.value = 0
    items.value = []
    isDone.value = false
    loadMore()
  }
})

watch(
  () => route.params.gid,
  async val => {
    group.value = val ? String(val) : null
    searchQuery.value = ''
    selectedItems.value.clear()
    await refresh()
  }
)

function onKeyDown(e) {
  if (e.key.toLowerCase() === 'r' && !e.metaKey && !e.ctrlKey) {
    e.preventDefault()
    if (group.value) refresh()
    else loadGroups()
  }
}

function goToNextItem() {
  if (!activeItem.value) return
  const idx = filteredItems.value.findIndex(i => i.url === activeItem.value.url)
  if (idx >= 0) activeItem.value = filteredItems.value[(idx + 1) % filteredItems.value.length]
}

function goToPreviousItem() {
  if (!activeItem.value) return
  const idx = filteredItems.value.findIndex(i => i.url === activeItem.value.url)
  if (idx >= 0) {
    activeItem.value =
      filteredItems.value[(idx - 1 + filteredItems.value.length) % filteredItems.value.length]
  }
}

async function onFilesPicked(e) {
  const files = Array.from(e.target.files || [])
  if (!files.length) return
  await performUpload(files)
  e.target.value = ''
}

function getFilesFromDataTransfer(dt) {
  const output = []
  if (!dt) return output
  if (dt.files && dt.files.length) {
    for (const f of dt.files) {
      const isImg = f.type.startsWith('image/')
      const isOtf =
        f.type === 'font/otf' ||
        f.type === 'application/x-font-otf' ||
        /\.otf$/i.test(f.name)
      if (isImg || isOtf) output.push(f)
    }
  }
  return output
}

async function onFilesDropped(e) {
  isDraggingOver.value = false
  const files = getFilesFromDataTransfer(e.dataTransfer)
  if (!files.length) return
  await performUpload(files)
}

async function performUpload(files) {
  if (!group.value) return
  try {
    isUploading.value = true
    await uploadImages(files, { group: group.value })
    await refresh()
  } catch (err) {
    error.value = err?.message || 'Upload failed'
  } finally {
    isUploading.value = false
  }
}

function confirmDeleteItem(item) {
  openConfirmModal('Delete File', `Are you sure you want to delete ${item.filename}?`, async () => {
    await deleteImage(item.filename, group.value || undefined)
    selectedItems.value.delete(item.url)
    await refresh()
  })
}

function toggleSelection(item) {
  if (selectedItems.value.has(item.url)) selectedItems.value.delete(item.url)
  else selectedItems.value.add(item.url)
}

function isSelected(item) {
  return selectedItems.value.has(item.url)
}

function clearSelection() {
  selectedItems.value.clear()
}

function selectAllVisible() {
  filteredItems.value.forEach(i => selectedItems.value.add(i.url))
}

const selectedItemsCount = computed(() => selectedItems.value.size)

function confirmBulkDelete() {
  openConfirmModal(
    'Delete Selected Items',
    `Delete ${selectedItemsCount.value} file(s)?`,
    async () => {
      const itemMap = new Map(filteredItems.value.map(i => [i.url, i]))
      const itemsToDelete = Array.from(selectedItems.value)
        .map(url => itemMap.get(url))
        .filter(Boolean)
      for (const item of itemsToDelete) {
        await deleteImage(item.filename, group.value || undefined)
      }
      selectedItems.value.clear()
      await refresh()
    }
  )
}

async function loadAndApplyFont(item) {
  const fontId = `font-preview-${item.url.replace(/[^a-zA-Z0-9]/g, '')}`
  if (loadedFonts.value.has(fontId)) return
  const styleId = `style-${fontId}`
  if (document.getElementById(styleId)) return
  const fontFace = `
    @font-face {
      font-family: '${fontId}';
      src: url('${item.absoluteUrl || item.url}');
    }
  `
  const styleEl = document.createElement('style')
  styleEl.id = styleId
  styleEl.textContent = fontFace
  document.head.appendChild(styleEl)
  loadedFonts.value.add(fontId)
}
</script>

<style>
.modal-enter-active,
.modal-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.menu-enter-active,
.menu-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top right;
}

.menu-enter-from,
.menu-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.list-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.list-move {
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.shadow-apple {
  box-shadow: 0 18px 55px rgba(15, 23, 42, 0.35);
}
</style>
